<template>
  <div :key="value">
    <label class="radio" :class="customClass" :style="{ border: checked ? '2px solid #3056d3' : '2px solid #d1d1d6' }">
      <input :name="name" :id="id" :value="value" type="radio" @change="handleChange" :checked="checked"/>
      <div :class="customClass_flex">
        <span :class="customClass_header">{{ value }}</span>
        <span :class="customClass_desc">{{ descriptionText }}</span>
      </div>
    </label>
  </div>
</template>

<script>
  export default {
    props: {
      name: [String, Number],
      descriptionText: String,
      checked: Boolean,
      id: [String, Number],
      customClass: String,
      customClass_flex: String,
      customClass_header: String,
      customClass_desc: String,
      value: [Number, String],
      handleChange: Function
    },
};
</script>

<style scoped>
.radio {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  cursor: pointer;
  user-select: none;
  gap: 8px;
  border-radius: 101px;
  border: 1px solid #d1d1d6;
  background: #fff;
  transition: all 150ms linear;

  &:focus-visible,
  &:hover {
      border-color: rgb(49, 130, 206);
  }

  input {
    display: none;
    & + span {
      display: inline-block;
      position: relative;
      padding-left: 30px;
      border-radius: 3px;
      &:before {
        content: "";
        display: block;
        position: absolute;
        top: 0px;
        left: 0px;
        border-radius: 3px;
        margin-right: 5px;
        width: 16px;
        height: 16px;
        border: 1px solid #ccc;
        background: #fff;
      }
      &:after {
        content: "";
        display: block;
        width: 10px;
        height: 10px;
        background: #222;
        position: absolute;
        border-radius: 3px;
        top: 3px;
        left: 3px;
        opacity: 0;
        transform: scale(0, 0);
        transition: all 0.2s cubic-bezier(0.64, 0.57, 0.67, 1.53);
      }
    }
    &:checked + span:after {
      opacity: 1;
      transform: scale(1, 1);
    }
  }
}
</style>
